import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import rootReducer, { rootSaga } from './modules';
import { composeWithDevTools } from 'redux-devtools-extension';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['userReducer', 'userCartReducer', 'esMyReducer']
}

export default () => {

    /* ------------- Redux Configuration ------------- */
    const middleware = [];
    const enhancers = [];

    /* ------------- Saga Middleware ------------- */
    const sagaMiddleware = createSagaMiddleware();
    middleware.push(sagaMiddleware);

    /* ------------- Assemble Middleware ------------- */
    enhancers.push(applyMiddleware(...middleware));

    const persistedReducer = persistReducer(persistConfig, rootReducer)
    const store = createStore(persistedReducer, composeWithDevTools(...enhancers));
    const persistor = persistStore(store)

    // kick off root saga
    sagaMiddleware.run(rootSaga)


    return { store, persistor }
}